import * as utils from '../utils';

export default async (uuid: string, message: string, from?: string): Promise<utils.IProviderResponse<Record<string, any>>> => {
  const url = `${process.env.REACT_APP_REST_API_ADDRESS}/api/v1/mobigrams/${uuid}/send_reply`;

  const body: Record<string, any> = {
    reply_message: message,
  };
  if (from) {
    body.replier_name = from;
  }

  let response;

  try {
    response = await fetch(url, {
      method: 'post',
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((res) => res.json());
  } catch (error) {
    return utils.ResponseError((error as Error).message);
  }

  if (response.error || !response.success) {
    return utils.ResponseError(response?.error || 'Failed to send reply. Please try again later.');
  }

  return utils.ResponseData(response);
};
